/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListSyndigoBrandsQueryResponse,
  ListSyndigoBrandsQueryParams,
} from '../types/ListSyndigoBrands'

function getListSyndigoBrandsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/products/catalog/variants/syndigo/brands/` as const,
  }
  return res
}

/**
 * @description Get brands for the company.
 * GET /catalog/variants/syndigo/brands/
 * Deprecated: Use GET /catalog/brands/ instead.
 * Returns:
 * Response with list of brand names sorted alphabetically.
 * Each item has 'label' and 'value' keys for frontend compatibility.
 * @summary List brands (deprecated, use /catalog/brands/)
 * {@link /api/v1/products/catalog/variants/syndigo/brands/}
 * @deprecated
 */
export async function listSyndigoBrands(
  params?: ListSyndigoBrandsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListSyndigoBrandsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListSyndigoBrandsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
